export default [
  {
    name: "aromatic",
    description: "Aromatic fragrances are more herbaceous and green in tone. Usually a blend of woods, lavender, herbs and warm citrus notes; aromatic scents are blended with care and attention to subtlety and wearablity. They make wonderful everyday fragrances and wear close to the skin. They have tremendous warmth and finesse.",
    fontColor: "#5150a6",
    background: "rgba(221,218,237,1)",
  },
  {
    name: "aquatic",
    description: "The Aquatic family was arguably made popular by Pierre Bourdon’s influential Cool Water for Davidoff and Issey Miyake’s classic scent. For their time they were revolutionary and introduced the world to ozonic notes, fresh air and the craving for clean detergent-like fragrances.",
    fontColor: "rgba(33,115,217,1)",
    background: "rgba(240,245,255,1)",
  },
  {
    name: "citrus",
    description: "Citrus fragrances are characterized by sharp, fresh tangy notes. They are a classic family of fragrances, containing lemon, lime, mandarin, grapefruit, orange and bergamot. Other notes such as pomelo, yuzu and cedrat can be used and complimented by the beautiful elements of the bitter orange tree such as neroli, petitgrain and orange blossom.",
    fontColor: "rgba(232,145,23,1)",
    background: "rgba(245,240,213,1)",
  },
  {
    name: "chypre",
    description: "Chypré fragrances are one of the truly great fragrance styles of all time. Chypré is French for Cyprus where much of the oakmoss was originally sourced from. The benchmark scent is François Coty’s Chypre de Coty from 1917. Real oakmoss is a vital component in chypré fragrances and is a defining note along with ciste-labdanum (a rock rose), patchouli, bergamot and the addition of jasmine and rose. They are some of the most tailored and sophisticated of all fragrances.",
    fontColor: "rgba(84,158,97,1)",
    background: "rgba(237,255,235,1)",
  },
  {
    name: "floral",
    description: "The floral family is a large and diverse family of fragrances including soliflores; single note florals such as Elisabethan Rose and Gardenia and floral bouquets. Fragrances created from several floral sources such as Ellenisia and the decadent tropical floral Amaranthine, created by Bertrand Duchaufour.",
    fontColor: "rgba(227,100,123,1)",
    background: "rgba(255,232,239,1)",
  },
  {
    name: "fougere",
    description: "Fougère fragrances are the masculine counterpart of the chypré. They are one of the oldest and most distinctive families in perfumery. Many of the world’s biggest masculine scents are fougère or fougère influenced: Antaeus by Chanel, Polo by Ralph Lauren, Geoffrey Beene’s Grey Flannel, and the much maligned Brut by Fabergé.",
    fontColor: "rgba(68,127,111,1)",
    background: "rgba(225,250,244,1)",
  },
  {
    name: "gourmand",
    description: "The gourmand family is relatively new. Mugler’s Angel exploded the gourmand facet into the industry, carving a candyfloss and patchouli shaped hole for itself. Gourmand, or foody scents, are arguably one of the most successful tastes in modern perfumery. They have been described as olfactory desserts.",
    fontColor: "rgba(252,76,155,1)",
    background: "rgba(255,240,246,1)",
  },
  {
    name: "oriental",
    description: "Oriental fragrances are some of the deepest, richest and most sensual fragrances in perfumery’s canon. They are defined by warm notes of vanilla, amber, balsams, incense, precious woods and musks. They are statement scents, bold and personal. Penhaligon’s have an eclectic range of oriental fragrances, from the soft nectarine blushed Artemisia and Malabah with its juicy ginger, rose and earl grey tea note.",
    fontColor: "rgba(162,50,70,1)",
    background: "rgba(237,218,221,1)",
  },
  {
    name: "woody",
    description: "The woody category is self explanatory, woody in tone, dry and fresh. Woods are beautiful notes in fragrance, elegant and distinctive, lending the wearer a touch of class and sophistication. Our woody fragrances include the bestselling Endymion, with its wonderful, swirling black coffee note, and Opus 1870, built around a blend of cedarwood, incense and sandalwood.",
    fontColor: "rgba(135,74,31,1)",
    background: "rgba(242,217,194,1)",
  }
]


// WEBPACK FOOTER //
// ./src/data/notes.js